import { localStorageAdapter } from '@/services/app.service';
import OptionExceptionModel from '@/models/OptionExceptionModel';
var optionsKey = 'options';
var optionExceptionsKey = 'option-exceptions';
var optionService = {
    addChoiceToOption: function (option, choice) {
        return option;
    },
    removeChoiceFromOption: function (option, choice) {
        return option;
    },
    getDefaultOptionChoices: function (options, optionException) {
        var choices = {};
        options.forEach(function (option) {
            var includedChoice = optionException.getIncludedChoiceForOption(option.id);
            choices[option.id] = includedChoice;
        });
        return choices;
    },
    setOptionsForStorage: function (options) {
        localStorageAdapter.setItem(optionsKey, options);
    },
    getOptionsFromStorage: function () {
        var options = localStorageAdapter.getItem(optionsKey);
        return options;
    },
    setOptionExceptionsForStorage: function (optionExceptions) {
        localStorageAdapter.setItem(optionExceptionsKey, optionExceptions);
    },
    getOptionExceptionsFromStorage: function () {
        var optionExceptions = localStorageAdapter.getItem(optionExceptionsKey);
        return optionExceptions;
    },
    convertToOptionExceptionModel: function (optionException) {
        return new OptionExceptionModel(optionException);
    }
};
export default optionService;



//////////////////
// WEBPACK FOOTER
// ./src/services/option.service.ts
// module id = xScY
// module chunks = 18